import React, {useState, useEffect, Fragment} from 'react'
import {useDispatch, useSelector} from "react-redux"

// Material-UI Core
import {makeStyles, withStyles} from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import Tooltip from '@material-ui/core/Tooltip'
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup'
import Chip from '@material-ui/core/Chip'

// Material-UI Lab
import ToggleButton from '@material-ui/lab/ToggleButton'

// Material-UI Icon
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import LocalOfferIcon from '@material-ui/icons/LocalOffer'

// Custom Component
import useLoading from "../Loading/useLoading"
import TabMenu from "../TabMenu/TabMenu"
import DrawingGeneral from "./DrawingGeneral"
import DrawingSketches from "./DrawingSketches"
import DrawingRelatedItem from "./DrawingRelatedItem"
import DrawingHistory from "./DrawingHistory"

// Custom Style
import {whiteColor, blackColor, grayColor, blueColor, nightOrangeColor, oceanBlueColor, DodgerBlueColor} from '../../styles/jss/cmsMainStyle'
import drawingDetailStyle from '../../styles/jss/components/drawingRegister/drawingDetailStyle'

// Fetch Data
import {getPurposeType, getDrawingDetail, getRelatedItems} from '../../dataSource/drawingRegister'


const CoverTitleTypography = withStyles({
	root: {
		"fontSize": 20,
		"fontWeight": 600,
		"color": oceanBlueColor[4]
	},
}) (Typography)

const CoverContntTypography = withStyles({
	root: {
		"fontSize": 15,
		"fontWeight": 400,
		"color": grayColor[8]
	},
}) (Typography)

const DrawingTypography = withStyles({
	root: {
		"fontSize": 18,
		"fontWeight": 400,
		"color": grayColor[8],
	},
}) (Typography)

const DrawingCategory = withStyles({
	root: {
		"fontSize": 15,
		"fontWeight": 400,
		"color": grayColor[8],
	},
}) (Typography)

const PurposeTypography = withStyles({
	root: {
		"fontSize": 13,
		"fontWeight": 600,
		// "color": "#ff3399"
	},
}) (Typography)


const useStyles = makeStyles(theme => drawingDetailStyle(theme))

const DrawingDetail = props => {
	const {selectedDrawing, annotSaveChangeAction, setAnnotSaveChangeAction} = props
	const store = require('store')
	const classes = useStyles()

	const [purposeType, setPurposeType] = useState(null)
	const [drawingDetailRecord, setDrawingDetailRecord] = useState(null)
	const [selectedDrawingSeq, setSelectedDrawingSeq] = useState(null)
	const [selectedRevisionSeq, setSelectedRevisionSeq] = useState(null)
	const [drawingRefash, setDrawingRefash] = useState("")

	const tabMenuProperty = [
		{
			tabIndex: 0,
			name: "General",
			form: <DrawingGeneral
					drawingDetailRecord={drawingDetailRecord}
					selectedRevisionSeq={selectedRevisionSeq}
					setSelectedRevisionSeq={setSelectedRevisionSeq}
					setDrawingRefash={setDrawingRefash}
					setAnnotSaveChangeAction={setAnnotSaveChangeAction}
					/*setAnnotSaveChangeWarningAction={setAnnotSaveChangeWarningAction}*/ />
		},
		{
			tabIndex: 1,
			name: "Sketches",
			form: <DrawingSketches
					drawingDetailRecord={drawingDetailRecord}
					selectedRevisionSeq={selectedRevisionSeq} 
					setDrawingRefash={setDrawingRefash} />
		},
		{
			tabIndex: 2,
			name: "Related Items",
			form: <DrawingRelatedItem
					drawingDetailRecord={drawingDetailRecord}
					selectedRevisionSeq={selectedRevisionSeq}
					setDrawingRefash={setDrawingRefash} />
		},
		{
			tabIndex: 3,
			name: "History",
			form: <DrawingHistory 
				drawingDetailRecord={drawingDetailRecord} />
		}
	]


	useEffect(() => {
		getPurposeType().then(res => {
			setPurposeType(res)
		})
		
		getDrawingDetail(selectedDrawing.dwg_seq).then(res => {
			setDrawingDetailRecord(res.data[0])

			setSelectedDrawingSeq(res.data[0].dwg_seq)
			setSelectedRevisionSeq(res.data[0].current_rev.rev_seq)
		})
	}, [drawingRefash])


	return (

		// console.log("Save Change Warning Flag | Variable: saveChangeWarning (DrawingDetail.js)"),
		// console.log(saveChangeWarning),

		// console.log("Purpose Type | Variable: purposeType (DrawingDetail.js)"),
		// console.log(purposeType),

		// console.log("Drawing Detail Record | Variable: drawingDetailRecord (DrawingDetail.js)"),
		// console.log(drawingDetailRecord),

		// console.log("---------------------------------------------------------------------------------"),

		<Fragment>
			{
				drawingDetailRecord ?
					<div>
						<Grid container spacing={2} className={classes.coverArea}>
							{
								drawingDetailRecord.dwg_cover_type.contain_ai ?
									<Grid item xs={12} sm={12} lg={drawingDetailRecord.dwg_cover_type.contain_ai && drawingDetailRecord.dwg_cover_type.contain_bd ? 6 : 12}>
										<Paper variant="outlined" className={classes.coverPaper}>
											<CoverTitleTypography>AI Cover</CoverTitleTypography>

											<div className={classes.coverContent}>
												<Tooltip title="Cover No" aria-label="cover_no">
													<CoverContntTypography>{drawingDetailRecord.dwg_covers.ai_cover_no}</CoverContntTypography>
												</Tooltip>

												<ChevronRightIcon color="primary" />

												<Tooltip title="Issue Date" aria-label="issue_date">
													<CoverContntTypography>{drawingDetailRecord.dwg_covers.ai_issue_date}</CoverContntTypography>
												</Tooltip>
											</div>

											<Tooltip title="Cover Subject" aria-label="cover_subject">
												<CoverContntTypography>{drawingDetailRecord.dwg_covers.ai_cover_subject}</CoverContntTypography>
											</Tooltip>
										</Paper>
									</Grid>
								: ""
							}

							{
								drawingDetailRecord.dwg_cover_type.contain_bd ?
									<Grid item xs={12} sm={12} lg={drawingDetailRecord.dwg_cover_type.contain_ai && drawingDetailRecord.dwg_cover_type.contain_bd ? 6 : 12}>
										<Paper variant="outlined" className={classes.coverPaper}>
											<CoverTitleTypography>BD Cover</CoverTitleTypography>

											<div className={classes.coverContent}>
												<Tooltip title="Cover No" aria-label="cover_no">
													<CoverContntTypography>{drawingDetailRecord.dwg_covers.bd_cover_no}</CoverContntTypography>
												</Tooltip>

												<ChevronRightIcon color="primary" />

												<Tooltip title="Issue Date" aria-label="issue_date">
													<CoverContntTypography>{drawingDetailRecord.dwg_covers.bd_issue_date}</CoverContntTypography>
												</Tooltip>
											</div>

											<Tooltip title="Cover Subject" aria-label="cover_subject">
												<CoverContntTypography>{drawingDetailRecord.dwg_covers.bd_cover_subject}</CoverContntTypography>
											</Tooltip>
										</Paper>
									</Grid>
								: ""
							}
						</Grid>

						<div className={classes.drawingArea}>
							<DrawingTypography>Drawing No.: {drawingDetailRecord.dwg_no}</DrawingTypography>
							<DrawingTypography>Drawing Title: {drawingDetailRecord.dwg_title}</DrawingTypography>
						</div>

						<div className={classes.drawingCategoryArea}>
							<Grid container spacing={1}>
								<Grid item xs={12} sm={12} lg={12}>
									<div className={classes.drawingType}>
										<Tooltip title="Drawing Type Group" aria-label="drawing_type_group">
											<DrawingCategory>{drawingDetailRecord.dwg_type_group_name}</DrawingCategory>
										</Tooltip>

										<ChevronRightIcon color="primary" />

										<Tooltip title="Drawing Type" aria-label="drawing_type">
											<DrawingCategory>{drawingDetailRecord.dwg_type_names.join(", ")}</DrawingCategory>
										</Tooltip>
									</div>
								</Grid>

								<Grid item xs={12} sm={12} lg={8}>
									<ToggleButtonGroup value={drawingDetailRecord.dwg_purposes} aria-label="dwg_purpose" className={classes.ToggleButtonGroup}>
										{
											purposeType ?
												purposeType.map(res => {
													return (
														<ToggleButton 
															key={res.purpose_seq}
															aria-label={res.purpose_name}
															value={res.purpose_seq}
															disabled
															className={classes.ToggleButton}
														>
															<PurposeTypography style={{color: res.color}}>{res.name}</PurposeTypography>
														</ToggleButton>
													)
												})
											: ""
										}
									</ToggleButtonGroup>
								</Grid>
							
								<Grid item xs={12} sm={12} lg={12}>
								{
									drawingDetailRecord.dwg_tags.map((x, index) => {
										return (
											<Chip
												style={{paddingLeft: 5, paddingRight: 5, paddingTop: 5, paddingBottom: 5, marginRight: 10}}
												key={index}
												variant="outlined"
												size="small"
												icon={<LocalOfferIcon />}
												label={x}
												color="primary"
											/>
										)
									})
								}
								</Grid>
							</Grid>
						</div>
						
						<TabMenu
							type = "secord"
							property = {tabMenuProperty}
							defaultTabValue = {0}
							annotSaveChangeAction={annotSaveChangeAction}
						/>
					</div>

				: <div></div>
			}
		</Fragment>
	)
}


export default DrawingDetail